import { Component } from 'react';
import logger from '../logger';
/**
 * The React {@link Component} which is similar to Web's
 * {@code HTMLAudioElement}.
 */
export default class AbstractAudio extends Component {
    /**
     * The {@link AudioElement} instance which implements the audio playback
     * functionality.
     */
    _audioElementImpl;
    /**
     * Initializes a new {@code AbstractAudio} instance.
     *
     * @param {IProps} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this.setAudioElementImpl = this.setAudioElementImpl.bind(this);
    }
    /**
     * Attempts to pause the playback of the media.
     *
     * @public
     * @returns {void}
     */
    pause() {
        this._audioElementImpl?.pause();
    }
    /**
     * Attempts to begin the playback of the media.
     *
     * 必须吞掉 play() 的 Promise rejection：入会提示音等在用户未点击页面前会触发
     * NotAllowedError，未捕获时 webpack-dev-server overlay 会盖住已进会的界面。
     *
     * @public
     * @returns {void}
     */
    play() {
        const result = this._audioElementImpl?.play();
        if (result && typeof result.catch === 'function') {
            result.catch(error => {
                // 自动播放策略拦截属预期；仅记 DEBUG，避免未捕获 rejection 干扰开发态
                logger.debug(`[音频] ${new Date().toISOString()} play() 被拦截或失败`
                    + ` | name=${error?.name} message=${error?.message}`);
            });
        }
    }
    /**
     * Set the (reference to the) {@link AudioElement} object which implements
     * the audio playback functionality.
     *
     * @param {AudioElement} element - The {@link AudioElement} instance
     * which implements the audio playback functionality.
     * @protected
     * @returns {void}
     */
    setAudioElementImpl(element) {
        this._audioElementImpl = element;
        const { setRef } = this.props;
        typeof setRef === 'function' && setRef(element ? this : null);
    }
    /**
     * Sets the sink ID (output device ID) on the underlying audio element.
     * NOTE: Currently, implemented only on Web.
     *
     * @param {string} sinkId - The sink ID (output device ID).
     * @returns {void}
     */
    setSinkId(sinkId) {
        this._audioElementImpl
            && typeof this._audioElementImpl.setSinkId === 'function'
            && this._audioElementImpl.setSinkId(sinkId)
                .catch(error => logger.error('Error setting sink', error));
    }
    /**
     * Attempts to stop the playback of the media.
     *
     * @public
     * @returns {void}
     */
    stop() {
        this._audioElementImpl?.stop();
    }
}
